export const DATA = [
  "Less than a year ago",
  "1 to 2 years ago",
  "More than 3 years ago",
  "Never",
];
